// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.card[data-v-2dcb2cba] {\n  box-shadow: var(--o-ring-offset-shadow),var(--o-ring-shadow),var(--o-shadow);\n  color: hsl(var(--o-card-foreground));\n  background-color: hsl(var(--o-card));\n  border-width: 1px;\n  border-radius: 0.5rem;\n  padding: 1.5rem;\n}\n\n", ""]);
// Exports
module.exports = exports;
